<template >

  <v-row v-if="!$apollo.loading">
    <v-col cols="2" offset-md="1">

    </v-col>
    <v-col cols="8">

      <v-file-input label="Foto Encabezado" @change="onFileChange($event)"></v-file-input>
      <v-btn @click="guardar" color="primary">Guardar</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
export default {
  apollo: {

  },
  name:"LoadPlayers",
  data() {
    return {
      file: null,
    }
  },
  methods: {
    guardar(){
      const data = {
        tournament_id : 1,
      }
      const formData = new FormData();
      formData.append(`file`, this.file );
      formData.append('data', JSON.stringify(data));
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      axios.post('/load_players_file/',formData,config)
      .then(() => {
        //window.location.href = "/"
      })
      .catch(error => {
        console.error(error)
      })
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    onFileChange(event){
      this.file = event.target.files[0];
    },
  },
  watch:{
    '$apollo.loading'(val){
      console.log(val)

    },
  }
}
</script>
<style>

</style>
